import styled, { css } from 'styled-components';
import { FontSize, FontWeight } from 'commons';

export const Main = styled.form`
  display: grid;
  gap: 10px 16px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 16px;
  min-width: 320px;
  overflow-x: auto;
  padding-bottom: 5px;
`;

export const TextAndTimeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: ${FontSize.font12};
  font-weight: ${FontWeight.regular};
  cursor: pointer;
`;

export const Container = styled.div<{ $danger: boolean }>`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 140px;
  border-radius: 10px;
  padding: 16px 8px;
  border: 1px solid ${({ theme }) => theme.neutral_500};

  ${({ $danger, theme }) =>
    $danger &&
    css`
      border: 1px solid ${({ theme }) => theme.danger_500};

      ${TextAndTimeWrapper} {
        opacity: 0.5;
      }

      ${Label} {
        color: ${theme.danger_500};
      }
    `}
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const TimesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-self: flex-end;
  gap: 5px;
`;
